import classNames from 'classnames'
import React from 'react'

function Checkbox({value, onChange, label, style}) {
  return <div className="toggle-block toggle-block--indent-bottom" style={style}>
      <div className="toggle-component">
        <span className={classNames("toggle-label", {active: !!value})}>{label}</span>
        <div className={classNames("react-toggle", {'react-toggle--checked': value})} onClick={() => {onChange(!value)}}>
          <div className="react-toggle-track">
            <div className="react-toggle-track-check"></div>
            <div className="react-toggle-track-x"></div>
          </div>
        <div className="react-toggle-thumb"></div>
      </div>
    </div>
  </div>
}

export default Checkbox


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionImport/components/Checkbox.jsx